import React from 'react';
import { AppBar, IconButton, Icon, Typography, Button, Toolbar } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
//css
import './appheader.css';

//services
import Session from '../../../services/auth/Session';


class AppHeader extends React.Component {
    render() {
		const { local } = this.props;
        return (
			<AppBar position="fixed" className="header_app" color="inherit" elevation={0} >
				<Toolbar>
					<IconButton edge="start" className="header_app__menu_button" color="inherit" aria-label="Menu">
						<Icon>menu</Icon>
					</IconButton>
					<Typography variant="h6" >
						{local.title}
					</Typography>
					<Button onClick={() => {
								if(Session.FecharSessao() === true){
									this.props.history.push('/painel/entrar');
								}
							}}
							variant="outlined"
							color="inherit">Sair</Button>
				</Toolbar>
			</AppBar>
        );
    }
}

export default withRouter(AppHeader)



// WEBPACK FOOTER //
// ./src/painel/components/AppHeader/index.js